<template>
  <div
    v-if="nextEpisode.id"
    class="c-next-episode"
  >
    <ui-popover center>
      <template #wrapper>
        <i
          v-accessibility-focus="playNextEpisode"
          class="o-icon o-icon--next"
          :aria-label="$t('accessibility.player.nextEpisode')"
        ></i>
      </template>
      <template #content>
        <div class="c-next-episode__content">
          <img
            :src="img"
            :alt="nextEpisode.title"
          >
          <p class="u-text-center u-ellipsis">
            S{{ nextEpisode.season.number }}E{{ nextEpisode.episode }}: {{ nextEpisode.title }}
          </p>
        </div>
      </template>
    </ui-popover>
  </div>
</template>
<script>
  import UiPopover from '@/shared/components/popover/index.vue';
  import { NextEpisodeMixin } from '@/shared/components/player/mixins';
  import { getLogo } from '@/shared/utils';

  export default {
    name: 'UiPlayerNextEpisode',
    components: { UiPopover },
    mixins: [
      NextEpisodeMixin,
    ],
    computed: {
      img() {
        return getLogo(this.nextEpisode);
      },
    },
  };
</script>
